// Lightweight RW officer auth utilities — independent from main AuthContext
// so the staff session and the RW session never collide.
import axios from "axios";

export const RW_TOKEN_KEY = "sipilkades-rw-token";

export function getRwToken() {
  try { return localStorage.getItem(RW_TOKEN_KEY) || ""; } catch { return ""; }
}

export function setRwToken(t) {
  try {
    if (t) localStorage.setItem(RW_TOKEN_KEY, t);
    else localStorage.removeItem(RW_TOKEN_KEY);
  } catch { /* noop */ }
}

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const rwApi = axios.create({ baseURL: API_BASE });
rwApi.interceptors.request.use((cfg) => {
  const t = getRwToken();
  if (t) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
  return cfg;
});

export function formatApiErr(err) {
  const d = err?.response?.data;
  if (typeof d === "string") return d;
  if (d?.detail) {
    if (Array.isArray(d.detail)) return d.detail.map((x) => x.msg || JSON.stringify(x)).join("; ");
    return typeof d.detail === "string" ? d.detail : JSON.stringify(d.detail);
  }
  return err?.message || "Terjadi kesalahan.";
}
